import styled from 'styled-components'

const CardListToolbar = styled.div``

export default CardListToolbar
